import {
  DialogProvider,
  ToastContent,
  Toaster,
} from "@endya-conformite/ui-kit";
import { ReactElement, useEffect } from "react";
import { Router } from "./Router";
import { UserSessionProvider } from "./session/UserSessionContext";
import { StoreProvider } from "./store/store";
import { StoreRefresher } from "./store/StoreRefresher";

import "@endya-conformite/ui-kit/src/style/app.scss";
import "@endya-conformite/ui-kit/src/style/lya-lib-override.scss";
import "@endya-conformite/ui-kit/src/lya/style";

function addEnvToTitle() {
  const hostnameSubdomain = window.location.hostname.split(".").at(0) ?? "";
  if (
    ["rec", "ppr", "localhost"].includes(hostnameSubdomain) &&
    !document.title.startsWith("[")
  ) {
    document.title = `[${hostnameSubdomain}] ${document.title}`;
  }
}

export function App(): ReactElement | null {
  useEffect(() => {
    addEnvToTitle();
  }, []);

  return (
    <UserSessionProvider>
      <StoreProvider>
        <StoreRefresher>
          <DialogProvider>
            <Toaster
              defaultHideAfter={5000}
              position={{
                vertical: "bottom",
                horizontal: "center",
              }}
              ToastContentComponent={ToastContent}
            />
            <Router />
          </DialogProvider>
        </StoreRefresher>
      </StoreProvider>
    </UserSessionProvider>
  );
}
